import { useState, useEffect } from 'react'
import { ICoordinates } from 'src/types'

export const useGeoLocation = () => {
  const [coords, setCoords] = useState<ICoordinates | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCoords({ latitude: position.coords.latitude, longitude: position.coords.longitude })
          setError(null)
        },
        (err) => {
          // console.error('Error getting geolocation:', err)
          setError('Please allow geolocation access to proceed')
        },
        { timeout: 10000 },
      )
    } else {
      const message = 'Geolocation is not supported by your browser'
      console.error(message)
      setError(message)
    }
  }, [])

  return { coords, error }
}
